import { useNavigate, useParams } from "react-router-dom";
import { ClinicianReviewItemView } from "@/features/clinician/review-queue/components/ClinicianReviewItemView";

/** A shared-queue item, view only, before claiming it (/clinician/queue/:itemId). */
export function ClinicianQueuePreviewPage() {
  const { itemId = "" } = useParams<{ itemId: string }>();
  const navigate = useNavigate();
  const back = () => navigate("/clinician");
  // Keyed per item so nothing from one item's screen survives into the next.
  return (
    <ClinicianReviewItemView
      key={itemId}
      itemId={itemId}
      mode="preview"
      backLabel="Review Queue"
      onBack={back}
      onReleased={back}
      // Claimed: now held — open the full item, replacing the preview in history.
      onClaimed={(id) => navigate(`/clinician/review/${encodeURIComponent(id)}`, { replace: true })}
    />
  );
}
